const Contact = () => {
    return (
        <div className="text-center">
            <span className="heading ">
            <h1 className="lgreen">Contact Us</h1></span>
            <p>For more information or any queries, please contact us at:</p>
            <h3><a href="mailto:life2024.iitk@gmail.com">life2024.iitk@gmail.com</a></h3>
        </div>
)}

export default Contact;